// --- GlobalContext ----
// On utilise le Context API natif de React pour faire descendre les datas
// sur tout l'arbre de composant
// Ex: import GlobalContext from '/contexts';

import {createContext} from 'react';
import I_STATE from './I_STATE';
import INITIAL_STATE from './INITIAL_STATE';
import reducer from './reducer';
import REDUCER_ACTIONS from './ACTIONS';

interface I_CONTEXT {
  state: I_STATE;
  dispatch: any;
}

const INITIAL_CONTEXT:I_CONTEXT = {
  state: INITIAL_STATE,
  dispatch: undefined,
};

const GlobalContext = createContext(INITIAL_CONTEXT);

export default GlobalContext;
export {reducer,REDUCER_ACTIONS,INITIAL_STATE};
